import MoreVertIconMui from '@mui/icons-material/MoreVert'
import { Box, Button, styled } from '@mui/material'
import { Colors } from '~/libs/mui/theme'
import { Video } from '~/types/api/videos'
import { VideoListItemMain } from './VideoListItemMain'

const VerticalThreeDotIcon = styled(MoreVertIconMui)({
  color: Colors.colorD7D9DB,
  cursor: 'pointer',
  '&:hover': {
    opacity: 0.5,
  },
})

interface VideoListItemProps {
  video: Video
  /** ビデオアイテムクリック */
  onClickVideoItem: () => void
  /** 三点リーダークリック */
  onClickPlayListAction?: () => void
}

export function VideoListItem({
  video,
  onClickVideoItem,
  onClickPlayListAction,
}: VideoListItemProps) {
  return (
    <Button
      onClick={onClickVideoItem}
      sx={{
        color: 'white',
        '&:hover': {
          backgroundColor: 'rgba(0, 0, 0, 0.12)',
        },
      }}
    >
      <Box display='flex'>
        <Box flexGrow={1}>
          <VideoListItemMain video={video} />
        </Box>
        {onClickPlayListAction && (
          <Box
            onClick={(e) => {
              e.stopPropagation()
              onClickPlayListAction()
            }}
          >
            <VerticalThreeDotIcon />
          </Box>
        )}
      </Box>
    </Button>
  )
}
